export const TEST_ID = 'homePointMarker';
